import { createSelector } from "reselect";

const getInitialState = (state) => state.client.client;
const getIsClientLoadedState = (state) => state.client.isClientLoaded;
const getIsSubmittingState = (state) => state.client.isSubmitting;

export default createSelector(
  [getInitialState, getIsClientLoadedState, getIsSubmittingState],
  (client, isClientLoaded, isSubmitting) => ({
    client,
    isClientLoaded,
    isSubmitting,
  })
);



// WEBPACK FOOTER //
// ./client/react/Admin/components/CustomerForm/selectors/index.js